// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"44105b7e","349":"5d958a06","729":"e54fa752","879":"4ba549c8"}[chunkId] + ".css";
};